import { render, staticRenderFns } from "./ApplicantUpdate.vue?vue&type=template&id=01e5593b&scoped=true&"
import script from "../../services/applicant/applicant-update.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-update.js?vue&type=script&lang=js&"
import style0 from "./ApplicantUpdate.vue?vue&type=style&index=0&id=01e5593b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5593b",
  null
  
)

export default component.exports